import {Component, ViewChild, ElementRef, AfterViewChecked, OnDestroy, HostListener} from '@angular/core';
import {DateSharedSelected} from "../../models/date-shared-selected";
import {Formatters} from 'app/slick-grid/models/formatters';
import {OrderOpened} from "../../../orders/models/order-opened";
import {Moment} from "moment";
import * as moment from 'moment';
import {DateTimeEditorOptions} from "../../models/date-time-editor-options";

@Component({
    selector: 'slick-datetime-picker',
    templateUrl: './slick-datetime-picker.component.html',
    styleUrls: ['../../../shared/styles/custom-scroll.css', './slick-datetime-picker.component.css']
})


export class SlickDatetimePickerComponent<T> implements AfterViewChecked, OnDestroy{
    // @ViewChild('button')
    // private button: ElementRef;


    // @ViewChild('dropdown')
    // private dropdown: ElementRef;


    private options: Slick.Editors.EditorOptions<T>;

    set editorOptions(options: Slick.Editors.EditorOptions<T>){
        this.options = options;
        this.item = options.item;
        this.column = options.column;
        this.selectedDt =
            //this.outEditorOptions && this.outEditorOptions.defaultDate
            this.item[this.column.field]
                ? moment.isMoment(this.item[this.column.field])
                    ? (this.item[this.column.field] as Moment).isValid()
                        ? moment.utc(this.item[this.column.field])
                        : null
                    : moment.utc(this.item[this.column.field])
                : this.outEditorOptions && this.outEditorOptions.defaultDate
                    ? moment.utc()
                    : null

        this.selectedDt = this.selectedDt && this.selectedDt.isValid()
            ? this.selectedDt
            : null

        this.dateForComponent = this.selectedDt ? this.selectedDt.format() : null;

        // console.log(this.selectedDt, this.dateForComponent, this.item[options.column.field], options.column.field, 'editorOptions')
        this.options.grid.onScroll.subscribe(e => this.hideDropdown(e));
    }


    public cssClass: Array<'small-height' | 'small-width' | 'width-auto' | 'grid-small' | 'main-wrp' | 'input-group' | 'very-small-width'>;
    set customClass(customClass: Array<'small-height' | 'small-width' | 'width-auto' | 'grid-small' | 'main-wrp' | 'input-group' | 'very-small-width'>) {
        this.cssClass = ['grid-small']
        if (customClass && customClass.length){
            this.cssClass = this.cssClass.concat(customClass)
        }

    }

    public item: T;
    public datePickerVisibilityControl: boolean;
    public column: Slick.Column<any>
    public outEditorOptions: DateTimeEditorOptions;
    public selectedDt: Moment;

    get selectedDate(): string{
        return Formatters.datetimeFormatter(0, 0, this.selectedDt);
    }

    set selectedDate(val: string){

    }

    get dateForComponent(): string{
        return this._dateForComponent;
    }

    set dateForComponent(val: string){
        if (this._dateForComponent !== val){
            this._dateForComponent = val
        }
    }

    private setFocus: boolean;
    public _dateForComponent: string;

    ngAfterViewChecked(): void{
        // if (!this.setFocus || !this.button)
        //     return;
        //
        // this.button.nativeElement.focus();
        // this.setFocus = false;
    }

    ngOnDestroy(): void{
        this.options.grid.onScroll.unsubscribe(this.hideDropdown);
    }

    public get formatter(): typeof Formatters{
        return Formatters;
    }

    focus = (): void => {
        // if (this.button)
        //     this.button.nativeElement.focus();
        // else
        //     this.setFocus = true;
    }

    // private isDropdownShown = (): boolean => {
    //     return window.getComputedStyle(this.dropdown.nativeElement).display !== 'none';
    // }

    private hideDropdown = (e?: Slick.EventData): void => {
        e && e.stopPropagation();
        e && e.stopImmediatePropagation();
        this.datePickerVisibilityControl = false;
    }

    public isTimeSelected = (date: string): boolean => {
        // console.log(moment(date).isSame(this.selectedDt, 'day'), moment.utc(date).format(), this.selectedDt.format(), );
        return moment(date).isSame(this.selectedDt, 'day');
        // return OrderSupplier.areEquals(this.selectedSupplier, supplier);
    }

    public onDateClicked = (date: string): void => {
        this.selectedDt = date ? moment.utc(date) : null;
        // this.focus();
    }

    /*public onLabelClicked = (e: MouseEvent): void => {
        e.stopPropagation();
        this.focus();
        $(this.dropdown.nativeElement).dropdown('hide')
    }*/

    /*public readonly buttonClick = (e: MouseEvent):void => {
        e.stopPropagation();
        $(this.dropdown.nativeElement).dropdown('toggle')
    }*/

    @HostListener('window:resize')
    private onGridScroll = (): void => {
        this.hideDropdown();
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/slick-datetime-picker.component/slick-datetime-picker.component.ts